/**
 * @fileOverview File with Header component
 * @description File containing Header function
 * @author Komal Chevli
 * @since 1.0.0
 */

import React from "react";

// core components
import PortalHeaderLinks from "./PortalHeaderLinks.jsx";

const Header = props => {

  return <div className="header">
    <PortalHeaderLinks {...props} />
  </div>
}


export default (Header);
